import type { ComponentProps } from 'react';
import React, { useEffect } from 'react';
import styled from '@emotion/styled';

import { GridItem } from 'common/components/Grid';
import { Link } from 'common/components/Link';
import { LinkRegularLR1 } from 'common/components/Typography';
import { useIsObserved } from 'common/hooks/intersection-observer';
import { useTrackingEvents } from './hooks';

type UspCtaLinkProps = ComponentProps<typeof Link> & {
  href: string;
  label: string;
};

const LinkWithArrow = styled(LinkRegularLR1)<any>`
  &::after {
    content: ' ›';
  }
`;

const linkWithArrowStyles: ComponentProps<typeof LinkWithArrow> = {
  as: Link,
  color: 'inherit',
};

export const UspCtaLink = ({ label, href }: UspCtaLinkProps) => {
  const [ref, isObserved] = useIsObserved();

  const { onView, onLinkClick } = useTrackingEvents({
    linkText: label,
    linkUrl: href,
  });

  useEffect(() => {
    if (isObserved) {
      onView();
    }
  }, [isObserved]);

  return (
    <GridItem mt="sp_16" mb="sp_32" ref={ref}>
      <LinkWithArrow {...linkWithArrowStyles} href={href} onClick={onLinkClick}>
        {label}
      </LinkWithArrow>
    </GridItem>
  );
};
